import { Title } from 'components'
import { Table } from '@sar/component'

import { Remark, UploadImage } from 'components'
import { ModalForm, ProFormDigit } from '@ant-design/pro-components'

async function fetchData (params, store) {
  const result = await store.externals.api.get(`/paymentRecords`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
      balancePayment: params.selected == 'other' ? '0' : params.balancePayment
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

function Update ({ data, store, visible, handles, onVisibleChange }) {
  return <ModalForm
    title='修改订单金额'
    layout='vertical'
    width={500}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true,
    }}
    onOpenChange={onVisibleChange}
    request={async () => ({ ...data, fileManageList: data.fileManageList ? data.fileManageList.map(e => ({ url: e.url, filename: e.fileName })) : [] })}
    onFinish={res => store.externals.api.put(`/paymentRecords/${data.id}`, { ...res, fileManageList: res.fileManageList.map(e => ({ url: e.url, fileName: e.filename })) }).then(() => setTimeout(() => handles.current.reload())).then(R.T)}
  >
    <ProFormDigit
      name='totalAmount'
      label='总金额'
      min={0}
      max={99999999}
      fieldProps={{ precision: 2 }}
      rules={[ { required: true, message: '请输入总金额' } ]}
    />

    <UploadImage
      max={10000}
      name='fileManageList'
      label='报价凭证'
      help='建议尺寸800*800px'
      fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
    />
  </ModalForm>
}

export default function ({ store, navigator }) {
  const [ selected, dispatch ] = React.useState('other')

  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
    },
    {
      title: '订单号',
      dataIndex: 'number',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
    },
    {
      title: '联系电话',
      dataIndex: 'customerPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
    },
    {
      title: '来源',
      dataIndex: 'customerSource',
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      fieldProps: { fieldNames: { value: 'id', label: 'source' } },
      request: () => store.externals.api.get(`/constant/source`),
    },
    {
      title: '查询时间',
      dataIndex: 'date',
      valueType: 'dateRange',
      hideInTable: true,
      fieldProps: { placeholder: [ '开始时间', '结束时间' ] },
    },
    selected == 'other' ? null : {
      title: '查询方式',
      dataIndex: 'balancePayment',
      valueType: 'select',
      valueEnum: {
        0: '只查询尾款订单',
      },
      hideInTable: true,
    },
    {
      title: '总金额',
      dataIndex: 'totalAmount',
    },
    {
      title: '待收付款',
      dataIndex: 'balance',
      render: (_, data) => data.totalAmount - data.paidAmount,
    },
    {
      title: '已收金额',
      dataIndex: 'paidAmount',
    },
    {
      title: '结算方式',
      dataIndex: 'payStatus',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
    },
    {
      title: '创建人',
      dataIndex: 'createName',
    },
    {
      title: '生产类型',
      dataIndex: 'type',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderType`),
    },
  ]

  const rowActions = [
    {
      name: '修改',
      form: props => <Update {...props} store={store} />,
      visible: () => store.identity.hasPermission('/collection/list:update'),
    },
    {
      name: '查看备注',
      form: props => <Remark {...props}/>,
    },
    {
      name: '查看',
      visible: () => store.identity.hasPermission('/collection/list/flow'),
      onClick: (data, handles) => navigator.to(`/collection/list/flow/${data.id}`, `收款流水列表（${data.id}）`),
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'number'
      , 'customerName'
      , 'customerAddress'
      , 'customerPhone'
      , 'sourceId'
      , 'date'
      , 'balancePayment'
    ]

    return columns.filter(R.identity).map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [ selected ])

  return <div className='p-4'>
    <Table
      title='收款列表'
      columns={cols}
      rowActions={rowActions}
      params={{ selected }}
      request={params => fetchData(params, store)}
      scroll={{ }}
      search={{ defaultCollapsed: false, span: store.config.responsive }}
      toolbar={{
        multipleLine: true,
        tabs: {
          activeKey: selected,
          onChange: dispatch,
          items: [
            { key: 'other', tab: '待收款' },
            { key: 'all', tab: '已收完' },
          ],
        },
      }}
    />
  </div>
}
